import classNames from "classnames";
import Typography, { ITypo } from "../Typography";
import classes from "./classes.module.scss";
import { useCallback, useId, useState } from "react";

type ITabItem = {
	label: string;
	children?: React.ReactNode;
};

type IProps = {
	items: (ITabItem | null)[];
	compact?: boolean;
};

export default function NavTabComponent(props: IProps) {
	const id = useId();
	const [selectItemId, setSelectItemId] = useState<number>(0);
	const onSelectItem = useCallback((itemId: number) => setSelectItemId(itemId), []);

	if (props.items.length <= 0) return null;

	return (
		<div className={classNames(classes["root"], props.compact && classes["compact"])}>
			<nav role="tablist">
				{props.items.map((item, index) => {
					if (!item) return null;
					return (
						<button
							key={index}
							type="button"
							role="tab"
							id={`${id}-tab-${index}`}
							aria-selected={index === selectItemId}
							aria-controls={`${id}-panel`}
							tabIndex={index === selectItemId ? 0 : -1}
							onKeyDown={(e) => {
								const indexes = props.items.flatMap((item, i) => (item ? [i] : []));
								const position = indexes.indexOf(index);
								const next =
									e.key === "ArrowRight"
										? indexes[(position + 1) % indexes.length]
										: e.key === "ArrowLeft"
											? indexes[(position + indexes.length - 1) % indexes.length]
											: e.key === "Home"
												? indexes[0]
												: e.key === "End"
													? indexes[indexes.length - 1]
													: undefined;
								if (next !== undefined) {
									e.preventDefault();
									onSelectItem(next);
									document.getElementById(`${id}-tab-${next}`)?.focus();
								}
							}}
							className={classNames(classes["link"], index === selectItemId && classes["active"])}
							onClick={() => onSelectItem(index)}>
							<Typography typo={ITypo.P_MEDIUM}>{item.label}</Typography>
						</button>
					);
				})}
			</nav>
			{props.items.length && (
				<div role="tabpanel" id={`${id}-panel`} aria-labelledby={`${id}-tab-${selectItemId}`} className={classes["content"]}>
					{props.items[selectItemId]?.children}
				</div>
			)}
		</div>
	);
}
